import React from "react";
import SidebarIndex from "../../../SidebarIndex";

export default function SidebarPanel(props) {
    const { company, tab } = props;
    const tabKey = tab.includes('%20') ? tab.replaceAll('%20', ' ') : tab;

    if (!company?.modules?.[tabKey]) return null;

    return <SidebarIndex {...props} isExternalPage={false} />;
}
